import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';

export default class ConfirmAccountRoute extends Route {
  @service alerts;
  @service session;
  @service signup;
  @service auth;

  beforeModel(transition) {
    let { confirmationCode } = transition.to.queryParams;

    if (!confirmationCode) {
      this._invalidConfirmationCodeAlert();
      return this.router.replaceWith('login');
    }

    return this.signup
      .confirmAccount({ confirmationCode })
      .then((response) => {
        this.alerts.success('confirmAccount.success', 'Confirmed your account');
        return this.session.authenticate('authenticator:access-token', { accessToken: response.access_token });
      })
      .catch((err) => {
        let errors = err.errors || [];
        if (errors.some((e) => e.detail === 'account already confirmed')) {
          let alreadyConfirmedMessage = this.session.isAuthenticated
            ? 'Account already confirmed'
            : 'Account already confirmed, please log in';

          this.alerts.error('confirmAccount.accountAlreadyConfirmed', alreadyConfirmedMessage);
        } else {
          this._invalidConfirmationCodeAlert();
        }

        return this.router.replaceWith('login');
      });
  }

  redirect() {
    return this.router.transitionTo('authenticated');
  }

  _invalidConfirmationCodeAlert() {
    return this.alerts.error('confirmAccount.invalidConfirmationCode', 'Account confirmation code is incorrect');
  }
}
